module.exports = __webpack_public_path__ + "static/media/Informativa_sui_Cookie_29-06.2020.117b318b.pdf";